import "./Modal.css";

import React, { ReactNode } from "react";

import { CloseDarkIcon } from "../../../assets";
import { OrganisationTypeConstants } from "../../../constants";
import { useAuth } from "../../../useAuth";
import { Backdrop } from "../Backdrop";
import { useModal } from "./useModal";

export interface ModalProps {
  show: boolean;
  title: string;
  onClose?: () => void;
  onBackdrop?: () => void;
  children: ReactNode[] | ReactNode;
  hasFullWidthTitle?: boolean;
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({
  show,
  title,
  children,
  onClose,
  onBackdrop,
  hasFullWidthTitle = false,
  className,
}): JSX.Element | null => {
  const { currentUserType } = useAuth();
  const { modalRefCallBack } = useModal({ show });
  const modalClassName =
    `Modal ${currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "AssetManagerRounded" : ""} ${
      className ?? ""
    }`.trim();

  return show ? (
    <>
      <div ref={modalRefCallBack} className={modalClassName}>
        <button className="ModalCloseIcon" onClick={onClose}>
          <CloseDarkIcon width={16} height={18} />
        </button>
        <h1 className={`${hasFullWidthTitle ? "FullWidthTitle" : ""}`}>{title}</h1>
        <div className="ModalContent">{children}</div>
      </div>
      <Backdrop show={show} onClick={onBackdrop} />
    </>
  ) : null;
};
